// frontend/src/components/common/Tooltip.jsx
import { useId, useState } from "react";
import "./ui.css";

/**
 * Lightweight CSS-positioned tooltip, shown on hover and keyboard focus.
 * side: top | bottom | left | right
 */
export default function Tooltip({ content, side = "top", children, className = "" }) {
  const id = useId();
  const [open, setOpen] = useState(false);
  if (!content) return children;

  return (
    <span
      className={`tooltip-wrap ${className}`.trim()}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
      aria-describedby={open ? id : undefined}
    >
      {children}
      <span id={id} role="tooltip" className={`tooltip tooltip--${side}${open ? " is-open" : ""}`}>
        {content}
      </span>
    </span>
  );
}
